import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthenticationEnvironment, ENVIRONMENT, UserDto } from '@warema/shared/models';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationConnectorService {
    private readonly _http = inject(HttpClient);
    private readonly _userUrl = inject<AuthenticationEnvironment>(ENVIRONMENT).userUrl;

    public getUserAndAddToApiCache(userId: string): Observable<UserDto> {
        return this._http.get<UserDto>(`${this._userUrl}/${userId}`, {}).pipe(
            map(user => {
                // fixup date objects
                user.registrationDate = new Date(user.registrationDate);
                user.loginDate = new Date(user.loginDate);
                if (user.lockoutEnd) {
                    user.lockoutEnd = new Date(user.lockoutEnd);
                }
                return user;
            }),
        );
    }
}
